import { OverviewPeriod, PeriodOption } from "./types";

export const PERIOD_OPTIONS: readonly PeriodOption[] = [
  { period: OverviewPeriod.OneDay, days: 1 },
  { period: OverviewPeriod.SevenDays, days: 7 },
  { period: OverviewPeriod.ThirtyDays, days: 30 },
] as const;

export const PERIOD_LABELS: Record<OverviewPeriod, string> = {
  [OverviewPeriod.OneDay]: "Today",
  [OverviewPeriod.SevenDays]: "Last 7 days",
  [OverviewPeriod.ThirtyDays]: "Last 30 days",
};